module.exports = __webpack_public_path__ + "static/img/clothing_texture.a987091.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/clothing_texture.png
// module id = w7Yr
// module chunks = 0